import axios from 'axios';
import { getBackendHost } from '../utils/backendHost';


const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('jwt_authorization')}`,
  },
});


function configurationFrom(response) {
  return response.data.receptionistConfiguration;
}


export async function getReceptionistConfiguration() {
  return configurationFrom(await axios.get(
    `${getBackendHost()}/v2/receptionist/configuration`,
    authConfig(),
  ));
}


export async function saveReceptionistDraft(changes) {
  return configurationFrom(await axios.patch(
    `${getBackendHost()}/v2/receptionist/configuration/draft`,
    changes,
    authConfig(),
  ));
}


export async function publishReceptionistDraft(expectedDraftVersion) {
  return configurationFrom(await axios.post(
    `${getBackendHost()}/v2/receptionist/configuration/publish`,
    { expectedDraftVersion },
    authConfig(),
  ));
}


export async function discardReceptionistDraft() {
  return configurationFrom(await axios.post(
    `${getBackendHost()}/v2/receptionist/configuration/discard`,
    {},
    authConfig(),
  ));
}
